import { BaseModal } from './_BaseModal'
import { Button } from 'components/atoms/buttons/Button'
import swal from 'sweetalert2'
import { FormProvider, useForm } from 'react-hook-form'
import { InputText } from 'components/atoms/inputs/InputText'
import { zodResolver } from '@hookform/resolvers/zod'
import { signUpUser } from 'api/user/signUpUser'
import { AuthoritySelector } from 'components/atoms/selects/AuthoritySelector'
import {
  SignupUserSchema,
  SignupUserSchemaType
} from 'schema/user/SignupUserSchema'

type Props = {
  onClose: () => void
}
export const SignupUserModal = (props: Props): JSX.Element | null => {
  const { onClose } = props
  const methods = useForm<SignupUserSchemaType>({
    defaultValues: {},
    resolver: zodResolver(SignupUserSchema)
  })

  const userSignupHandler = async (data: any) => {
    const [firstName, lastName] = data.name.split(' ')
    const requestParams = {
      email: data.email,
      password: data.password,
      firstName: firstName,
      lastName: lastName || '',
      authorityCode: data.authorityCode as 'GENERAL' | 'ADMIN',
      userCode: data.userCode
    }
    await signUpUser(requestParams)
      .then(() => {
        swal
          .fire({
            icon: 'info',
            text: 'ユーザーを追加しました。',
            confirmButtonText: 'OK'
          })
          .then((result) => {
            if (result.isConfirmed) {
              onClose()
            } else {
              return
            }
          })
      })
      .catch((error: any) => {
        swal.fire({
          icon: 'error',
          text: error?.data?.message || 'ユーザーの追加に失敗しました。',
          confirmButtonText: 'OK'
        })
      })
  }

  return (
    <BaseModal style={`w-[400px]`}>
      <FormProvider {...methods}>
        <div className={'mb-2 flex'}>
          <span className={'text-gray-600'}>{'ユーザー追加'}</span>
        </div>
        <form onSubmit={methods.handleSubmit(userSignupHandler)}>
          <InputText name={'userCode'} label={'ユーザーID'} required />
          <InputText name={'name'} label={'名前'} required />
          <InputText name={'email'} label={'メールアドレス'} required />
          <InputText
            name={'password'}
            label={'パスワード'}
            required
            type={'password'}
          />
          <AuthoritySelector name={'authorityCode'} />
          <div className={'mt-4 flex justify-between'}>
            <div className={'w-20'}>
              <Button label={'追加'} />
            </div>
            <div className={'w-20'}>
              <Button label={'閉じる'} clickHandler={onClose} />
            </div>
          </div>
        </form>
      </FormProvider>
    </BaseModal>
  )
}
